// extracted by mini-css-extract-plugin
module.exports = {"header":"SiteInfoSubHeader_header__vv7yx"};